/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Pipe, PipeTransform } from '@angular/core';
import { differenceInMinutes, differenceInHours, isToday, isYesterday, format } from 'date-fns';

@Pipe({
    name: 'relativeDate',
    standalone: false
})
export class RelativeDatePipe implements PipeTransform {
    public transform(value: string | Date): string {
        if (!value) return '';

        const date = new Date(value);
        const now = new Date();

        const minutesDiff = differenceInMinutes(now, date);
        const hoursDiff = differenceInHours(now, date);

        // 🕐 Under en timme → visa minuter
        if (minutesDiff < 60) {
            if (minutesDiff < 1) return 'Just now';
            return `${minutesDiff} minute${minutesDiff > 1 ? 's' : ''} ago`;
        }

        // 🕒 Under ett dygn → visa timmar
        if (hoursDiff < 24 && isToday(date)) {
            return `${hoursDiff} hour${hoursDiff > 1 ? 's' : ''} ago`;
        }

        // 🗓️ Igår → visa tid
        if (isYesterday(date)) {
            return `Yesterday ${format(date, 'HH:mm')}`;
        }

        // 📆 Samma år → dag + månad
        if (date.getFullYear() === now.getFullYear()) {
            return format(date, 'd MMM'); // t.ex. "11 Oct"
        }

        // 📅 Annars → dag + månad + år
        return format(date, 'd MMM yyyy');
    }
}
